export const TextVariants = {
  xs: "xs",
  xsSemi: "xsSemi",
  sm: "sm",
  smSemi: "smSemi",
  md: "md",
  mdSemi: "mdSemi",
  lg: "lg",
  lgSemi: "lgSemi",
  xl: "xl",
  xlSemi: "xlSemi",
};

export const HeadingVariants = {
  largeXl: "largeXl",
  largeLg: "largeLg",
  largeMd: "largeMd",
  largeSm: "largeSm",
  largeXs: "largeXs",
  smallLg: "smallLg",
  smallLgSemi: "smallLgSemi",
  smallMd: "smallMd",
  smallSm: "smallSm",
};

export const ButtonVariants = {
  solid: "solid",
  outline: "outline",
  ghost: "ghost",
  link: "link",
};

export const CommonVariants = {
  unstyled: "unstyled",
};
